import Configurations from './Configurations.view';

export default Configurations;
